import {REHYDRATE} from 'redux-persist/lib/constants';

import {TOGGLE_STREAM_PLAYBACK_DEBUG_MODE, TOGGLE_YUNAI_OUTPUT_MODE} from '@actions/actionTypes';
import {mergeRehydrate} from '@reducers/rehydrateUtils';

export const initialState = {debugMode: false, yunaiOutputMode: false};

const streamPlaybackReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_STREAM_PLAYBACK_DEBUG_MODE:
            return {
                ...state,
                debugMode: !state.debugMode,
            };
        case TOGGLE_YUNAI_OUTPUT_MODE:
            return {...state, yunaiOutputMode: !state.yunaiOutputMode};
        case REHYDRATE: {
            return {
                ...initialState,
                ...mergeRehydrate(action, 'payload.app.streamPlayback', {}),
            };
        }
        default:
            return state;
    }
};

export default streamPlaybackReducer;
